export interface Option {
  label: string;
  value: string;
}

export const ENTITY_TYPES: Option[] = [
  { label: 'Pipeline', value: 'Pipeline' },
  { label: 'Models/Workflows', value: 'Models/Workflows' },
  { label: 'Billing', value: 'Billing' },
  { label: 'Login/User Access', value: 'Login/User Access' },
  { label: 'Alerts & Notifications', value: 'Alerts & Notifications' },
];

// Issue categories mapped to each entity type
export const ISSUE_CATEGORIES_BY_ENTITY: Record<string, Option[]> = {
  Pipeline: [
    { label: 'Stuck Pipeline', value: 'Stuck Pipeline' },
    { label: 'Pipeline Creation Failure', value: 'Pipeline Creation Failure' },
    { label: 'Ingestion Failure', value: 'Ingestion Failure' },
    { label: 'Load Failure', value: 'Load Failure' },
    { label: 'Mapping Issues', value: 'Mapping Issues' },
    { label: 'Data Mismatch Issues', value: 'Data Mismatch Issues' },
    { label: 'Failed Events', value: 'Failed Events' },
    { label: 'Pipeline Performance', value: 'Pipeline Performance' },
  ],
  'Models/Workflows': [
    { label: 'Stuck Model', value: 'Stuck Model' },
    { label: 'Model/Workflow Creation failure', value: 'Model/Workflow Creation failure' },
    { label: 'Data Mismatch', value: 'Data Mismatch' },
    { label: 'Query Failure', value: 'Query Failure' },
    { label: 'Performance Issues', value: 'Performance Issues' },
  ],
  Billing: [
    { label: 'Failed Payment', value: 'Failed Payment' },
    { label: 'Incorrect Invoice', value: 'Incorrect Invoice' },
    { label: 'High Quota Usage', value: 'High Quota Usage' },
    { label: 'Others', value: 'Others' },
  ],
  'Login/User Access': [
    { label: 'Unable to login/signup', value: 'Unable to login/signup' },
    { label: 'Unable to add/update user', value: 'Unable to add/update user' },
    { label: 'SAML/SSO setup', value: 'SAML/SSO setup' },
    { label: 'Others', value: 'Others' },
  ],
  'Alerts & Notifications': [
    { label: 'Missing Notification', value: 'Missing Notification' },
    { label: 'High Alerts', value: 'High Alerts' },
    { label: 'Incorrect Alert', value: 'Incorrect Alert' },
    { label: 'Others', value: 'Others' },
  ],
};

